module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div ng-show="$ctrl.show" ng-cloak>\n  <a\n    href\n    class="btn btn-default"\n    data-original-title="<strong>{{ $ctrl.tooltiptitle }}</strong><br/>{{ $ctrl.tooltipmessage }}"\n    data-toggle="tooltip"\n    data-placement="left"\n    data-html="true"\n    ng-click="$ctrl.removeFeatures()"\n  >\n    <i class="fas fa-times"></i>\n  </a>\n</div>\n';

}
return __p
}